import fileDownload from 'js-file-download';
import { useCallback } from 'react';
import {
  AdminFeedbackFilters,
  useExportAdminFeedback,
} from 'src/api/queries/chatAdmin/useAdminFeedback';
import { formatDate } from 'src/utils';

export interface IUseFeedbackExportResult {
  exportCsv: (filters: AdminFeedbackFilters) => Promise<void>;
  exporting: boolean;
}

/** CORS hides Content-Disposition from the browser, so the name is built here. */
export const feedbackExportFileName = (exportedAt: Date): string =>
  `fire-feedback-${formatDate(exportedAt, 'YYYY-MM-DD')}.csv`;

/** Failures toast through the global mutation error pipeline, so this hook shows none itself. */
export const useFeedbackExport = (): IUseFeedbackExportResult => {
  const { mutateAsync, isPending } = useExportAdminFeedback();

  const exportCsv = useCallback(
    async (filters: AdminFeedbackFilters) => {
      const file = await mutateAsync(filters).catch(() => null);
      if (file) fileDownload(file.data, feedbackExportFileName(new Date()));
    },
    [mutateAsync],
  );

  return { exportCsv, exporting: isPending };
};
